console.log("".concat(process.env.NODE_ENV, " build v").concat(PACKAGE_VERSION, " (").concat(COMMIT_ID, ")"));
if (DEVELOPMENT) {
    console.log('https://tudoku.papergame.ru/tudoku/admin');
}
